// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'

// import '../sys'
// 自己写的样式
import './style/theme.css'
import './style/characters.css'
Vue.config.productionTip = false
// 添加请求拦截器
axios.interceptors.request.use(
  (config) => {
    // 从本地存储中获取token
    const tokenName = localStorage.getItem('tokenName');
    const tokenValue = localStorage.getItem('tokenValue');
    // 如果token存在，则在请求头部添加Bearer令牌
    if (tokenValue) {
      config.headers.Authorization = `${tokenName} ${tokenValue}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error)
  }
)

Vue.prototype.$axios = axios
Vue.use(ElementUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js